var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagMar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28,
    height: 19,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 1H1V19H28V1Z",
    fill: "url(#paint0_linear_245_12920)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9346 13.9501L12.9147 10.9331L10.3486 9.06907H13.5207L14.5013 6.0498L15.482 9.06907H18.654L16.0879 10.9331L17.068 13.9501L14.5013 12.0855L11.9346 13.9501ZM15.0043 11.7199L15.9432 12.4019L15.5844 11.2982L15.0043 11.7199ZM13.4177 11.2982L13.0589 12.4019L13.9978 11.7199L13.4177 11.2982ZM13.6099 10.7071L14.5013 11.3548L15.3928 10.7071L15.0523 9.6601H13.9498L13.6099 10.7071ZM12.1687 9.6601L13.107 10.3415L13.3284 9.6601H12.1687ZM15.8957 10.3415L16.834 9.6601H15.6743L15.8957 10.3415ZM14.142 9.06907H14.8606L14.5013 7.96366L14.142 9.06907Z",
    fill: "#00833E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_12920",
    x1: 1,
    y1: 9.99991,
    x2: 27.9997,
    y2: 9.99991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE1A17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE1A17"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMar);
export default __webpack_public_path__ + "static/media/flagMAR.5c8cc7e79a2896cf3beb12bc8c2422f2.svg";
export { ForwardRef as ReactComponent };